import{ Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './layout/header/header';
import { Footer } from './layout/footer/footer';
import { Overlay } from './shared/ui/overlay/overlay';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, Overlay],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('bdoiofw-familyshield');
}
